import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './AddDriverButtons.css';
import Button from '../../components/UI/Button/Button';


class AddDriverButtons extends Component {
    render () {        
        return (
            <div className={classes.AddDriverButtons}>
                
                <Button 
                    btnType="Success"
                    clicked={this.props.onAddDriver}>ADD DRIVER</Button>
                <Button 
                    btnType="Danger"
                    clicked={this.props.onCancelled}>CANCEL</Button>                
            </div>
        );
    }
};

export default ( AddDriverButtons);


// WEBPACK FOOTER //
// ./src/components/DriverButtons/AddDriverButtons.js